import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { Icon } from '@holmescorp/base-widgets';
import { Card, CardProperties } from '@holmescorp/card';
import { publish } from '@holmescorp/pub-sub';
import css from '../css/rcs-card.m.css';

export interface RCSCardProperties extends CardProperties<string> {
	path: string;
	title: string;
	button_label?: string;
	subtitle?: string;
	classes?: string;
	external_link?: string;
	isDisabled?: string;
}

const factory = create({
	theme
}).properties<RCSCardProperties>();

export const RCSCard = factory(({ id, properties, middleware: { theme } }) => {
	const {
		nlsKey = '',
		mediaSrc = '',
		mediaTitle = '',
		path,
		title,
		subtitle = '',
		button_label = '',
		classes = '',
		ispromotedisabled = 'true',
		ispromotable = 'false',
		ispromoted = 'false',
		external_link,
		isDisabled = 'false'
	} = properties();

	const themeCss = theme.classes(css);

	return v('div', { id, classes: [theme.variant(), themeCss.root, classes] }, [
		w(Card, { mediaSrc, mediaTitle, nlsKey, ispromotable, ispromotedisabled, ispromoted }, [
			{
				content: v('div', { classes: [themeCss.content] }, [
					v('div', { classes: [themeCss.title] }, [title]),
					v('div', { classes: [themeCss.subtitle] }, [subtitle]),
					v('div', { classes: [themeCss.actions] }, [
						w(
							Button,
							{
								onClick: () => {
									if (external_link) {
										window.open(external_link, '_blank');
									} else {
										publish(`rcs/view/${path}`, { title });
									}
								},
								onDown: () => {
									if (external_link) {
										window.open(external_link, '_blank');
									} else {
										publish(`rcs/view/${path}`, { title });
									}
								},
								aria: { label: `${button_label} ${title}` },
								disabled: isDisabled === 'true',
								iconPosition: 'after'
							},
							[
								{
									icon:
										isDisabled === 'true'
											? v('span', { styles: { paddingLeft: '5px' } }, [
													w(Icon, { faname: 'lock' })
											  ])
											: undefined,
									label: button_label
								}
							]
						)
					])
				])
			}
		])
	]);
});

export default RCSCard;
